const count = (value) =>
  Number.isSafeInteger(value) && value >= 0 ? value : null;
const aliases = {
  scheduledCents: "scheduled_cents",
  ruledCents: "ruled_cents",
  leavesTotal: "leaves_total",
  leavesRuled: "leaves_ruled",
  leavesPartial: "leaves_partial",
};
export const normalizeDisbursementCoverage = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const result = Object.fromEntries(
    Object.entries(aliases).map(([key, alias]) => [
      key,
      count(Object.hasOwn(value, key) ? value[key] : value[alias]),
    ]),
  );
  const orphanRules = Object.hasOwn(value, "orphanRules")
    ? value.orphanRules
    : value.orphan_rules;
  return {
    ...result,
    percentage:
      Number.isFinite(value.percentage) &&
      value.percentage >= 0 &&
      value.percentage <= 1
        ? value.percentage
        : null,
    orphanRules: Array.isArray(orphanRules) ? orphanRules : [],
  };
};
export const coverageServicesLabel = (coverage) =>
  coverage?.leavesRuled == null || coverage?.leavesTotal == null
    ? "Contagem de serviços indisponível."
    : `${coverage.leavesRuled.toLocaleString(
        "pt-BR",
      )} de ${coverage.leavesTotal.toLocaleString(
        "pt-BR",
      )} serviços já têm regra; o restante segue à vista.`;
